import Box from '@mui/material/Box';
import Grow from '@mui/material/Grow';
import Alert from '@mui/material/Alert';
import Typography from '@mui/material/Typography';
import Link from '@mui/material/Link';

export default function GoogleLagTimesAlert() {
  return (
    <Box width={600}>
      <Grow in={true}>
        <Alert severity="info">
          <Typography variant="caption">
            Per Google documentation, there is a lag time of 3 days or longer
            for specific data points. Please refer to the link below for
            additional details:
          </Typography>
          <br />
          <Link
            target="_blank"
            rel="noreferrer noopener"
            href="https://support.google.com/a/answer/7061566"
          >
            Data retention and lag times
          </Link>
        </Alert>
      </Grow>
    </Box>
  );
}
